import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ModalModule } from 'ngx-bootstrap/modal';

import { SharedModule } from 'shared/shared.module';
import { ProductPanelComponent } from './product-panel.component';
import { ProductPanelService } from './product-panel.service';
import { DetailService } from './services/detail.service';
import { ItemDetailsComponent } from './components/item-details/item-details.component';
import { DescriptionComponent } from './components/description/description.component';
import { AttributesComponent } from './components/attributes/attributes.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { KitsComponent } from './components/kits/kits.component';
import { UserAttributesComponent } from './components/attributes/user-attributes/user-attributes.component';
import { SuggestedAttributesComponent } from './components/attributes/suggested-attributes/suggested-attributes.component';
import { PackagingComponent } from './components/packaging/packaging.component';
import { DimensionsComponent } from './components/packaging/dimensions/dimensions.component';
import { ShippingInformationComponent } from './components/packaging/shipping-information/shipping-information.component';
import { AdditionalInformationComponent } from './components/packaging/additional-information/additional-information.component';
import { HazardousMaterialsComponent } from './components/packaging/hazardous-materials/hazardous-materials.component';
import { RegulatedInformationComponent } from './components/packaging/regulated-information/regulated-information.component';
import { ExtendedInformationComponent } from './components/packaging/extended-information/extended-information.component';
import { InterchangeComponent } from './components/interchange/interchange.component';
import { FitmentsComponent } from './components/fitments/fitments.component';
import { DigitalAssetsComponent } from './components/digital-assets/digital-assets.component';
import { AssigningAssetsComponent } from './components/digital-assets/assigning-assets/assigning-assets.component';
import { PCDBModalComponent } from './components/pcdb-modal/pcdb-modal.component';
import { AppSummaryModalComponent } from './components/app-summary-modal/app-summary-modal.component';
import { CustomFieldsComponent } from './components/custom-fields/custom-fields.component';

import { BaseSegmentComponent } from './components/base/_base-segment.component';
import { BasePackagingComponent } from './components/packaging/_base-packaging.component';

import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { TableEditableService } from 'shared/table/table-editable/table-editable.service';

import { PartNumberService } from './components/kits/part-number.service';
import { SuggestedAttributesService } from './components/attributes/suggested-attributes/suggested-attributes.service';
import { AttributesService } from './components/attributes/attributes.service';
// eslint-disable-next-line max-len
import { PrimaryPhotoWarningModalComponent } from './components/digital-assets/primary-photo-warning-modal/primary-photo-warning-modal.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        ModalModule.forRoot(),
        TypeaheadModule.forRoot(),
    ],
    declarations: [
        ProductPanelComponent,
        ItemDetailsComponent,
        DescriptionComponent,
        AttributesComponent,
        PricingComponent,
        UserAttributesComponent,
        SuggestedAttributesComponent,
        PackagingComponent,
        DimensionsComponent,
        ShippingInformationComponent,
        AdditionalInformationComponent,
        HazardousMaterialsComponent,
        RegulatedInformationComponent,
        ExtendedInformationComponent,
        KitsComponent,
        InterchangeComponent,
        FitmentsComponent,
        DigitalAssetsComponent,
        AssigningAssetsComponent,
        PCDBModalComponent,
        AppSummaryModalComponent,
        CustomFieldsComponent,
        BaseSegmentComponent,
        BasePackagingComponent,
        PrimaryPhotoWarningModalComponent,
    ],
    exports: [
        ProductPanelComponent
    ],
    providers: [
        DetailService,
        ProductPanelService,
        SegmentValidationService,
        TableEditableService,
        PartNumberService,
        SuggestedAttributesService,
        AttributesService,
    ]
})
export class ProductPanelModule {}
